export default function (context, val) {
    context.commit('list/remove', val);
    axios({
        method: 'post',
        url: '/tourclient/payment/deletePayment?DetailId=' + val.DetailId,
        data: 'DetailId=' + val.DetailId,
        requestId: '/tourclient/payment/deletePayment'
    }).then(({data}) => {
        if(data.ConfirmDeleteDetails){
            axios({
                method: 'post',
                url: '/tourclient/payment/deletePayment?DetailId=' + val.DetailId+'&DeleteWithPayment=true',
                data: 'DetailId=' + val.DetailId+'&DeleteWithPayment=true',
                requestId: '/tourclient/payment/deletePayment'
            }).then(({data}) => {
                window.app.$message({
                    type: 'success',
                    message: 'Распределение удалено'
                });
            }).catch(e => {
                context.dispatch('error', e, {root: true});
            })
        }else{
            window.app.$message({
                type: 'success',
                message: 'Распределение удалено'
            });
        }
    }).catch(e => {
        context.dispatch('error', e, {root: true});
    })
}